<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="80px" :inline="true" size="small" class="query-form" @submit.native.prevent>
<!--              <el-form-item label="课程">-->
<!--                  <el-input  v-model="queryForm.courseId"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item label="用户">
<!--                  <el-input  v-model="queryForm.userId"></el-input>-->
                  <GridSelectU style="width: 177px;" labelName="userName"
                               labelValue="id" title="选择用户" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                               @getValue="getSearchValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
<!--              <el-form-item label="过期时间">-->
<!--                  <el-input  v-model="queryForm.expireTime"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="学习进度">-->
<!--                  <el-input  v-model="queryForm.studyProgress"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="学习时长（秒数）">-->
<!--                  <el-input  v-model="queryForm.studyTime"></el-input>-->
<!--              </el-form-item>-->
<!--              <el-form-item label="最后学习时间">-->
<!--                  <el-input  v-model="queryForm.lastStudyTime"></el-input>-->
<!--              </el-form-item>-->
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getEduCourseStudentList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addEduCourseStudent"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editEduCourseStudent(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteEduCourseStudent(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshEduCourseStudentList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="eduCourseStudentList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
<!--      <el-table-column-->
<!--        :show-overflow-tooltip="true"-->
<!--        align="center"-->
<!--        prop="courseId"-->
<!--        label="课程"-->
<!--        width="180"-->
<!--      > </el-table-column>-->
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="用户"
        width="180"
      >
          <template slot-scope="scope">
              <div v-if="scope.row.user">
                  <div style="text-align: left">账号：{{ scope.row.user.userName }}</div>
                  <div style="text-align: left">手机：{{ scope.row.user.userMobile }}</div>
                  <div style="text-align: left">昵称：{{ scope.row.user.userNickname }}</div>
                  <div style="text-align: left">姓名：{{ scope.row.user.userRealname }}</div>
              </div>
              <div v-else>--</div>
          </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="expireTime"
        label="过期时间"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="studyProgress"
        label="学习进度"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="studyTime"
        label="学习时长（秒数）"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="lastStudyTime"
        label="最后学习时间"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
              <div @click="addStudy(scop.row.id)" v-if="status === 1">
                  <Icon size="16">
                      <Eye24Regular />
                  </Icon>
                  <span class="operation-label">学习记录</span>
              </div>
            <div @click="checkEduCourseStudent(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editEduCourseStudent(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteEduCourseStudent(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="eduCourseStudentStates[eduCourseStudentState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
      :append-to-body="true"
    >
      <div>
        <el-form
          :model="eduCourseStudent"
          ref="eduCourseStudentForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
<!--          <el-form-item-->
<!--            label="课程"-->
<!--            prop="courseId"-->
<!--          >-->
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduCourseStudent.courseId"-->
<!--              :disabled="eduCourseStudentState == 'check'"-->
<!--            ></el-input>-->
<!--          </el-form-item>-->
          <el-form-item
            label="用户"
            prop="userId"
          >
<!--            <el-input-->
<!--              size="small"-->
<!--              v-model="eduCourseStudent.userId"-->
<!--              :disabled="eduCourseStudentState == 'check'"-->
<!--            ></el-input>-->
              <GridSelectU style="width: 177px;" labelName="userName"
                           labelValue="id" title="选择用户" :value="eduCourseStudent.userId" :limit='1' size='small' placeholder='请选择用户' :disabled="eduCourseStudentState == 'check'"
                           @getValue="getValueUser" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="过期时间"
            prop="expireTime"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="eduCourseStudent.expireTime"
              :disabled="eduCourseStudentState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="学习进度"
            prop="studyProgress"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="eduCourseStudent.studyProgress"
              :disabled="eduCourseStudentState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="学习时长(秒数)"
            prop="studyTime"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="eduCourseStudent.studyTime"
              :disabled="eduCourseStudentState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="最后学习时间"
            prop="lastStudyTime"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="eduCourseStudent.lastStudyTime"
              :disabled="eduCourseStudentState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="eduCourseStudentState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
      <!--   学习记录   -->
      <el-dialog
          title="学习记录"
          :visible.sync="showStudyDialog"
          width="60%"
          @close="closeStudyDialog"
          :append-to-body="true"
      >
          <EduCourseCharpterStudyrecord style="height: 500px" ref="study"></EduCourseCharpterStudyrecord>
          <div
              slot="footer"
              class="flex justify-end"
          >
              <el-button @click="closeStudyDialog">关闭</el-button>
          </div>
      </el-dialog>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { USER, USER_SEARCH } from '@/utils/constant';
import EduExerciseExamAnalysis from '@/components/edu/EduExerciseExamAnalysis.vue';
import EduCourseCharpterStudyrecord from '@/components/edu/EduCourseCharpterStudyrecord.vue';

export default {
    components: {
        EduCourseCharpterStudyrecord,
        EduExerciseExamAnalysis,
        GridSelectU,
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetEduCourseStudentList();
                    this.getEduCourseStudentList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetEduCourseStudentList();
                    this.getEduCourseStudentList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                queryForm:{
                     courseId: '', //课程
                     userId: '', //用户
                     expireTime: '', //过期时间
                     studyProgress: '', //学习进度
                     studyTime: '', //学习时长（秒数）
                     lastStudyTime: '', //最后学习时间
                },
                loading: false,
                showDialog: false,
                showStudyDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                eduCourseStudentState: 'add',
                eduCourseStudentStates: {
                    add: '添加学员',
                    check: '查看学员',
                    edit: '修改学员'
                },
                USER_code: USER,
                USER_search: USER_SEARCH,
                multipleSelection: [],
                eduCourseStudentList: [],
                eduCourseStudent: {
                    id: '', //
                    courseId: '', //课程
                    userId: '', //用户
                    expireTime: '', //过期时间
                    studyProgress: '', //学习进度
                    studyTime: '', //学习时长（秒数）
                    lastStudyTime: '', //最后学习时间
                },
                btnLoading: false,

                rules: {
                    id: [{ required: true, message: '不能为空', trigger: 'blur' }],
                    courseId: [{ required: true, message: '课程不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '用户不能为空', trigger: 'blur' }],
                    expireTime: [{ required: true, message: '过期时间不能为空', trigger: 'blur' }],
                    studyProgress: [{ required: true, message: '学习进度不能为空', trigger: 'blur' }],
                    studyTime: [{ required: true, message: '学习时长（秒数）不能为空', trigger: 'blur' }],
                    lastStudyTime: [{ required: true, message: '最后学习时间不能为空', trigger: 'blur' }],
                },
                status: 1,
            };
        },
        created() {

        },
        methods: {
            search(){
                this.isSearch = !this.isSearch;
            },
            init(id, sign){
                this.status = sign;
                this.queryForm.courseId = id;
                this.eduCourseStudent.courseId = id;
                this.getEduCourseStudentList();
            },
            addStudy(id){
                this.showStudyDialog = true;
                this.$nextTick(()=>{
                    this.$refs.study.init(id, this.queryForm.courseId)
                })
            },
            closeStudyDialog(){
                this.showStudyDialog = false
            },
            getValueUser(value){
                this.eduCourseStudent.userId = value
            },
            getSearchValueUser(value){
                this.queryForm.userId = value
            },
            resetEduCourseStudentList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.eduCourseStudentList = [];
            },
            resetDialog() {
                this.eduCourseStudentState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      courseId: this.queryForm.courseId, //课程
                      userId: '', //用户
                      expireTime: '', //过期时间
                      studyProgress: '', //学习进度
                      studyTime: '', //学习时长（秒数）
                      lastStudyTime: '', //最后学习时间
                };
                this.getEduCourseStudentList();
            },
            closeDialog() {
                this.showDialog = false
                this.eduCourseStudent = {
                      id: '', //
                      courseId: this.eduCourseStudent.courseId, //课程
                      userId: '', //用户
                      expireTime: '', //过期时间
                      studyProgress: '', //学习进度
                      studyTime: '', //学习时长（秒数）
                      lastStudyTime: '', //最后学习时间
                };
            },
            submitForm() {
                if (this.eduCourseStudentState == 'add') {
                    this.$refs.eduCourseStudentForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/edu/coursestudent/add`,{ ...this.eduCourseStudent }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetEduCourseStudentList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.eduCourseStudentState == 'edit') {
                    this.$refs.eduCourseStudentForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            delete this.eduCourseStudent.user
                            post(`/edu/coursestudent/edit`,{ ...this.eduCourseStudent }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetEduCourseStudentList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addEduCourseStudent() {
                this.showDialog = true;
                this.eduCourseStudentState = 'add';
            },
            checkEduCourseStudent(eduCourseStudentId) {
                console.log(eduCourseStudentId);
                this.currentEduCourseStudentId = eduCourseStudentId;

                this.getEduCourseStudentById();
                this.showDialog = true;
                this.eduCourseStudentState = 'check';
            },
            editEduCourseStudent(eduCourseStudentId) {
                console.log('eduCourseStudent', eduCourseStudentId);
                if (eduCourseStudentId) {
                    this.currentEduCourseStudentId = eduCourseStudentId;
                    this.getEduCourseStudentById();
                } else {
                    this.eduCourseStudent = { ...this.eduCourseStudent, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.eduCourseStudentState = 'edit';
            },
            deleteEduCourseStudent(eduCourseStudentId) {
                let ids = '';
                if (eduCourseStudentId) {
                    ids = eduCourseStudentId;
                } else {
                    ids = this.multipleSelection.map((eduCourseStudent) => eduCourseStudent.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/edu/coursestudent/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetEduCourseStudentList();
                                this.getEduCourseStudentList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshEduCourseStudentList() {
                this.resetEduCourseStudentList();
                this.getEduCourseStudentList();
            },
            getEduCourseStudentList(query = {}) {
                this.loading = true;
                get(`/edu/coursestudent/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.eduCourseStudentList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getEduCourseStudentById() {
                get(`/edu/coursestudent/get`,{ id: this.currentEduCourseStudentId }).then((res) =>{
                    if(res.success){
                      this.eduCourseStudent = { ...this.eduCourseStudent, ...res.eduCourseStudent };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportEduCourseStudentList() {
                //this.btnLoading = true;
                exprotExcel(`/edu/coursestudent/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/edu/coursestudent/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/edu/coursestudent/importData`,formData);
              this.refreshEduCourseStudentList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getEduCourseStudentList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getEduCourseStudentList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>